import { render, staticRenderFns } from "./ProjetoPendente.vue?vue&type=template&id=bfc8c9e4&scoped=true&"
import script from "./ProjetoPendente.vue?vue&type=script&lang=js&"
export * from "./ProjetoPendente.vue?vue&type=script&lang=js&"
import style0 from "./ProjetoPendente.vue?vue&type=style&index=0&id=bfc8c9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc8c9e4",
  null
  
)

export default component.exports